var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.677419,
    y: 0.677419,
    width: 20.6452,
    height: 20.6452,
    rx: 4.19355,
    fill: "#32BA7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16129 10.4032L7.87097 7.69354C8.02151 7.54301 8.19893 7.43548 8.40323 7.37096C8.60753 7.30645 8.8172 7.29569 9.03226 7.3387L9.87097 7.51612C9.29032 8.2043 8.83333 8.82795 8.5 9.38709C8.16667 9.94623 7.84409 10.6237 7.53226 11.4193L5.16129 10.4032ZM8.46774 11.871C8.71505 11.0968 9.05118 10.3656 9.47613 9.67741C9.90108 8.98924 10.4144 8.34408 11.0161 7.74193C11.9624 6.79569 13.043 6.0886 14.2581 5.62064C15.4731 5.15268 16.6075 5.01032 17.6613 5.19354C17.8441 6.24731 17.7043 7.38172 17.2419 8.59677C16.7796 9.81182 16.0753 10.8925 15.129 11.8387C14.5376 12.4301 13.8925 12.9437 13.1935 13.3793C12.4946 13.815 11.7581 14.1563 10.9839 14.4032L8.46774 11.871ZM12.9194 9.93548C13.1667 10.1828 13.4705 10.3064 13.831 10.3064C14.1914 10.3064 14.4951 10.1828 14.7419 9.93548C14.9892 9.68817 15.1129 9.38451 15.1129 9.02451C15.1129 8.66451 14.9892 8.36064 14.7419 8.1129C14.4946 7.86559 14.1908 7.74193 13.8303 7.74193C13.4699 7.74193 13.1662 7.86559 12.9194 8.1129C12.672 8.36021 12.5484 8.66408 12.5484 9.02451C12.5484 9.38494 12.672 9.6886 12.9194 9.93548ZM12.4677 17.6935L11.4355 15.3226C12.2312 15.0107 12.9114 14.6882 13.4761 14.3548C14.0409 14.0215 14.6671 13.5645 15.3548 12.9839L15.5161 13.8226C15.5591 14.0376 15.5484 14.2501 15.4839 14.46C15.4194 14.6699 15.3118 14.8499 15.1613 15L12.4677 17.6935ZM6.19355 13.9355C6.56989 13.5591 7.02688 13.3682 7.56452 13.3626C8.10215 13.357 8.55914 13.5426 8.93548 13.9193C9.31183 14.2957 9.5 14.7527 9.5 15.2903C9.5 15.828 9.31183 16.2849 8.93548 16.6613C8.66667 16.9301 8.21785 17.1613 7.58903 17.3548C6.96022 17.5484 6.09183 17.7204 4.98387 17.871C5.13441 16.7634 5.30645 15.8978 5.5 15.2742C5.69355 14.6505 5.92473 14.2043 6.19355 13.9355Z",
    fill: "#F8F8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.677419,
    y: 0.677419,
    width: 20.6452,
    height: 20.6452,
    rx: 4.19355,
    stroke: "#DEDEDE",
    strokeWidth: 0.645161
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/Launch.d0af0753de7823a40a12483c038d29d5.svg";
export { ForwardRef as ReactComponent };